import { SnackbarProvider } from 'notistack'
import { memo, type PropsWithChildren, useMemo } from 'react'

import { Toast } from '../../toast.tsx'
import { TemporaryNotificationAlert } from '../temporary-notification/temporary-notification.tsx'

export const TemporaryNotificationAlertProvider = memo<PropsWithChildren>(function TemporaryNotificationAlertProvider({
  children,
}) {
  const components = useMemo(() => ({ default: TemporaryNotificationAlert }), [])

  return (
    <SnackbarProvider
      Components={components}
      maxSnack={3}
      hideIconVariant
      autoHideDuration={null}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      {children}
    </SnackbarProvider>
  )
})

export const ToastProvider = memo<PropsWithChildren>(function ToastProvider({ children }) {
  const components = useMemo(() => ({ default: Toast }), [])

  return (
    <SnackbarProvider
      Components={components}
      maxSnack={3}
      hideIconVariant
      autoHideDuration={4500}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      {children}
    </SnackbarProvider>
  )
})
